export default __webpack_public_path__ + "static/char-01-anr-e17f48c6b722ee9e8c7704cf8df29a61.gif";